const today = new Date();
const eighteenYearsBefore = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
const oneUndredYearsBefore = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate());
const convertstringToDate = (date: String) => {
    return `${date.substring(3, 5)}/${date.substring(0, 2)}/${date.substring(6, 10)}`;
};
export const isValidDate = (date: String) => {
    if (date.length < 10) return false;
    const temp = new Date(convertstringToDate(date));
    const valid = temp instanceof Date && !isNaN(temp.valueOf());
    return valid;
};
export const validateDateMax = (date: String) => {
    const temp = new Date(convertstringToDate(date));
    return temp < eighteenYearsBefore;
};
export const validateDateMin = (date: String) => {
    const temp = new Date(convertstringToDate(date));
    return temp > oneUndredYearsBefore;
};
